exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo-switching-container[data-v-3a15562b]{width:100%;height:100%;border-radius:7px;position:relative}.rotate-content[data-v-3a15562b]{transform-origin:50% 200%;-webkit-transform-origin:50% 200%;background:#ccc;will-change:transform}.back-photo-mask[data-v-3a15562b],.rotate-content[data-v-3a15562b]{position:absolute;left:0;top:0;width:100%;height:100%;border-radius:7px}.back-photo-mask[data-v-3a15562b]{background:rgba(0,0,0,.6)}.loading-card[data-v-3a15562b]{width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden;border-radius:7px}.side-circie[data-v-3a15562b]{width:70px;height:70px;position:absolute;z-index:20;text-align:center;line-height:70px;border-radius:50%;overflow:hidden;top:0;bottom:0;margin:auto 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a15562b","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/lib/photo_switching.vue
// module id = 4
// module chunks = 0